// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tooltip-resize {\n  width: 200px;\n  word-break: break-word;\n}\n.v-tooltip__content {\n  background: #001e38;\n  color: #fff;\n}\n@media (max-width: 768px) {\nbody .wrapper {\n    min-width: unset !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
